import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { iAxios } from '../../../lib/utils';
import { useMilestone, useTeamList } from '../../../lib/hooks';
import { StatusLabel } from '../../common/Helper';
import Icon from '../../ds/Icon';

const Reportees = ({ data, leadEmail, msgList, inFilter, isRoot }) => {
    const rows = data.filter(item => {
        if (!inFilter(item)) {
            return false;
        }
        if (isRoot) {
            // Show as a root when this member's lead isn't itself visible, so a
            // selected sub-team still appears even if its parent lead is filtered out.
            return !data.some(d => d.email === item.teamLead && inFilter(d));
        }
        return item.teamLead === leadEmail;
    });
    if (rows.length === 0) {
        return null;
    }
    return (
        <ol className={isRoot ? 'team-list' : ''}>
            {rows.map(item => {
                let msg = msgList.find(m => m.username === item.username);
                const isCritical = !msg && !item.memberStats;
                if (isCritical) {
                    msg = { msg: 'Need to add tickets for the sprint' };
                }
                return (
                    <li key={item.username}>
                        <span className={classNames('team-row', { 'is-missing': !item.memberStats })}>
                            <Link to={`/member/${item.username}`}>{item.name}</Link>
                            {item.data?.status && <StatusLabel info={item.data} compact />}
                            {msg?.msg && (
                                <span className={classNames('team-alert', { 'is-critical': isCritical })} tabIndex={0} title={msg.msg}>
                                    <Icon name="alert" />
                                    <span className="team-alert__pop">{msg.msg}</span>
                                </span>
                            )}
                        </span>
                        <Reportees data={data} leadEmail={item.email} msgList={msgList} inFilter={inFilter} isRoot={false} />
                    </li>
                );
            })}
        </ol>
    );
};

const Leads = (props) => {
    const [data, setData] = useState([]);
    const [msgList, setMsgList] = useState([]);
    const milestone = useMilestone();
    const userList = useTeamList();
    const userFilter = useSelector(st => st.tickets.userFilter);

    // Apply the header people filter; when nothing is selected, show everyone.
    const filterSet = userFilter.length ? new Set(userFilter.map(u => u.username)) : null;
    const inFilter = (item) => !filterSet || filterSet.has(item.username);

    useEffect(() => {
        if (!milestone) {
            return;
        }
        setData(null);
        iAxios.get(`/api/v1/tickets/team-status/`, {
            params: { start: milestone.start, end: milestone.end }
        }).then(res => {
            setMsgList(res.data.data);
        });
    }, [milestone, props.userList]);

    useEffect(() => {
        const nData = userList.map(item => {
            const group = props.statsList.find(u => u.uname === item.username);
            return Object.assign(item, { memberStats: group ? group.getStats(milestone) : null });
        });
        setData(nData);
    }, [props.statsList, userList, milestone]);

    return (
        <div className="ds-panel">
            <div className="ds-panel__head">
                <h3 className="ds-panel__title">Team</h3>
            </div>
            <div className="ds-panel__body">
                {!data && (
                    <div style={{ textAlign: 'center', padding: 'var(--ds-space-8)' }}>
                        <span className="ds-spinner" />
                    </div>
                )}
                {data && <Reportees data={data} leadEmail={null} msgList={msgList} inFilter={inFilter} isRoot={true} />}
            </div>
        </div>
    );
};

export default Leads;
